/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Moderly(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.8738 4.08311L16.5458 8.72099C16.1075 8.97204 15.5596 8.97204 15.1213 8.72099L6.80712 4.08311C6.31402 3.80563 5.71134 3.80563 5.21824 4.08311L2.06788 5.84048C1.57478 6.11796 1.27344 6.62007 1.27344 7.16182V21.6172C1.27344 22.1589 1.57478 22.661 2.06788 22.9385L15.0255 30.153C15.5186 30.4305 16.1212 30.4305 16.6143 30.153L29.5993 22.9385C30.0924 22.661 30.3937 22.1589 30.3937 21.6172V7.17503C30.3937 6.63328 30.0924 6.11796 29.5993 5.85369L26.4489 4.09632C25.9695 3.80563 25.3669 3.80563 24.8738 4.08311ZM15.0528 24.8809L6.80712 20.2959C6.31402 20.0184 6.01268 19.5163 6.01268 18.9745V8.91919L15.0392 13.9535C15.5323 14.2309 16.1349 14.2309 16.628 13.9535L25.6682 8.91919V18.9613C25.6682 19.5031 25.3669 20.0184 24.8738 20.2826L16.628 24.8677C16.1486 25.1584 15.5459 25.1584 15.0528 24.8809Z"
        fill="#7DB0F0"
      />
      <path
        d="M15.8472 25.4573C15.8472 25.312 15.7377 25.1799 15.587 25.1402C15.5048 25.1138 15.4226 25.0874 15.3541 25.0477L6.82076 20.2909C6.32766 20.0135 6.02632 19.5113 6.02632 18.9696V15.6663C6.02632 15.4813 5.87566 15.3359 5.68389 15.3359H1.64321C1.45145 15.3359 1.30078 15.4813 1.30078 15.6663V21.9294C1.30078 22.2729 1.49254 22.59 1.79388 22.7618L15.3404 30.3066C15.5733 30.4256 15.8472 30.2802 15.8472 30.0159V25.4573Z"
        fill="url(#paint0_linear_13974_172433)"
      />
      <path
        d="M15.8516 25.4573C15.8516 25.312 15.9611 25.1799 16.1118 25.1402C16.194 25.1138 16.2762 25.0874 16.3447 25.0477L24.878 20.2909C25.3711 20.0135 25.6725 19.5113 25.6725 18.9696V15.6663C25.6725 15.4813 25.8231 15.3359 26.0149 15.3359H30.0556C30.2473 15.3359 30.398 15.4813 30.398 15.6663V21.9294C30.398 22.2729 30.2063 22.59 29.9049 22.7618L16.3584 30.3066C16.1255 30.4256 15.8516 30.2802 15.8516 30.0159V25.4573Z"
        fill="url(#paint1_linear_13974_172433)"
      />
      <path
        d="M6.03611 8.90829L1.29688 6.26562V17.1138L6.03611 17.0873V8.90829Z"
        fill="url(#paint2_linear_13974_172433)"
      />
      <path
        d="M30.4091 6.25V17.151L25.6836 17.0717V8.90588L30.4091 6.25Z"
        fill="url(#paint3_linear_13974_172433)"
      />
      <path
        d="M25.6818 3.63281L16.8608 8.54817C16.2308 8.90493 15.45 8.90493 14.8199 8.54817L6.02633 3.63281L1.30078 6.27548L15.8472 14.3885L30.4074 6.27548L25.6818 3.63281Z"
        fill="#3C73F6"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13974_172433"
          x1="5.43145"
          y1="18.3773"
          x2="9.65336"
          y2="26.1812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DB0F0" />
          <stop offset="0.2368" stopColor="#5E91ED" />
          <stop offset="0.3264" stopColor="#6194ED" />
          <stop offset="1" stopColor="#7DB0F0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13974_172433"
          x1="26.2619"
          y1="18.3773"
          x2="22.04"
          y2="26.1812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DB0F0" />
          <stop offset="0.2368" stopColor="#5E91ED" />
          <stop offset="0.3264" stopColor="#6194ED" />
          <stop offset="1" stopColor="#7DB0F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13974_172433"
          x1="3.66403"
          y1="13.9639"
          x2="3.66403"
          y2="7.67337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DB0F0" />
          <stop offset="1" stopColor="#5F86B7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13974_172433"
          x1="28.0456"
          y1="15.4589"
          x2="28.0456"
          y2="7.09795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DB0F0" />
          <stop offset="1" stopColor="#5F86B7" />
        </linearGradient>
      </defs>
    </svg>
  )
}

Moderly.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Moderly
